import { render } from "./healthReport.vue?vue&type=template&id=6450a162&scoped=true&ts=true"
import script from "./healthReport.vue?vue&type=script&lang=ts"
export * from "./healthReport.vue?vue&type=script&lang=ts"

import "./healthReport.vue?vue&type=style&index=0&id=6450a162&lang=less&scoped=true"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6450a162"]])

export default __exports__